module.exports = __webpack_public_path__ + "static/design-debates-3f7101a62239738e44148e9489bebed1.mp4";